<template>
  <div id="viewerContainer">
    <app-main-menu></app-main-menu>
    <camera-background v-if="cameraActive" id="cameraBackground"></camera-background>
    <div id="viewerHostContainer" :style="{ 'background-color': backgroundColor }">
      <app-viewer></app-viewer>
    </div>
    <app-side-drawer v-show="sideDrawer !== null"></app-side-drawer>
  </div>
</template>

<script>
import SideDrawer from "@/components/SideDrawer";
import MainMenu from "@/components/MainMenu";
import Viewer from "@/components/Viewer";
import CameraBackground from "@/components/CameraBackground";

import { mapState } from "vuex";

export default {
  components: {
    "app-main-menu": MainMenu,
    "app-viewer": Viewer,
    "camera-background": CameraBackground,
    "app-side-drawer": SideDrawer
  },
  computed: {
    ...mapState(["backgroundColor", "cameraActive", "sideDrawer"])
  }
};
</script>

<style scoped>
#viewerContainer {
  background-color: rgba(201, 201, 201, 1);
  width: 100%;
  height: 100%;
  margin-left: 0px;
  position: relative;
}

#viewerHostContainer {
  height: 200px;
  width: 100%;
  padding-left: 56px;
  background-color: transparent;
  position: absolute;
}

#cameraBackground {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  z-index: 1;
}
</style>
